import { useMemo } from "react";
import { parsePath, useSearchParams, type To } from "react-router-dom";

import { keepRelevantSearchParams } from "@/utils/utils";

export const toWithPreservedRelevantSearch = (
  pathname: string,
  searchParams: URLSearchParams,
): string | To => {
  const parsedPath = parsePath(pathname);

  if (parsedPath.search) {
    return parsedPath;
  }

  const qs = keepRelevantSearchParams(searchParams);
  if (!qs) {
    return pathname;
  }
  return { ...parsedPath, search: `?${qs}` };
};

/**
 * For URL-backed tabs: same pathname with registry/editor filter params preserved from the current URL.
 */
export const useUrlTabLinkTo = (pathname: string | null): string | To | null => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    if (!pathname) {
      return null;
    }
    return toWithPreservedRelevantSearch(pathname, searchParams);
  }, [pathname, searchParams]);
};
